/** Topsort ID pool size for sold PDP YMAL (grid up to 40 + optional carousel leftovers). */
export const SOLD_MW_PDP_YMAL_SL_SIZE = 50;
export const SOLD_MW_PDP_YMAL_SL_SUBSEQUENT = 8;
export const SOLD_MW_PDP_YMAL_ITEMS_PER_ROW = 2;
/** Organic items the sold PDP container fetches and paints up front; mirrors its `count: 8`. */
export const SOLD_MW_PDP_YMAL_ML_INITIAL = 8;
/** Sponsored first window is sized 1:1 with the organic first paint. */
export const SOLD_MW_PDP_YMAL_SL_INITIAL = 8;
export const SOLD_MW_PDP_YMAL_MAXIMUM_SIZE = 80;
/** Max display rows for sold PDP YMAL (SL2 + ML2 alternating). */
export const SOLD_MW_PDP_YMAL_MAXIMUM_ROWS = 40;
export const SOLD_MW_PDP_YMAL_FEATURED_CAROUSEL_CAPACITY = 10;

export const MAXIMUM_MW_YMAL_ITEMS_COUNT = 40;
export const ML_MW_ITEMS_INITIAL_COUNT = 4;
export const MORE_ML_MW_ITEMS_FETCH_COUNT = 8;

/** 0-indexed row indices 0, 2, 4… — SL row then organic row, up to 40 rows. */
export const PDP_MW_SPONSORED_ROW_INDICES: readonly number[] = Array.from(
    { length: SOLD_MW_PDP_YMAL_MAXIMUM_ROWS / 2 },
    (_, i) => i * 2
);
